import React, { useState } from "react";

// Simplified Mexico map with state paths
const MEXICO_STATES = {
  "Baja California": { path: "M 50 50 L 70 40 L 85 60 L 90 100 L 70 130 L 50 120 Z", center: [70, 85] },
  "Baja California Sur": { path: "M 55 135 L 75 125 L 95 150 L 90 200 L 60 210 L 45 180 Z", center: [70, 170] },
  "Sonora": { path: "M 95 45 L 140 35 L 180 50 L 185 110 L 140 130 L 95 100 Z", center: [140, 80] },
  "Chihuahua": { path: "M 145 50 L 200 45 L 230 70 L 235 140 L 190 160 L 145 130 Z", center: [190, 100] },
  "Coahuila": { path: "M 205 75 L 270 70 L 290 100 L 280 160 L 230 170 L 200 140 Z", center: [245, 120] },
  "Nuevo León": { path: "M 280 90 L 320 85 L 340 120 L 330 165 L 290 170 L 275 140 Z", center: [305, 130] },
  "Tamaulipas": { path: "M 320 100 L 360 95 L 380 150 L 360 220 L 320 230 L 305 170 Z", center: [340, 160] },
  "Sinaloa": { path: "M 100 130 L 150 120 L 165 160 L 155 220 L 110 230 L 90 190 Z", center: [125, 175] },
  "Durango": { path: "M 155 130 L 210 125 L 230 170 L 220 230 L 170 240 L 150 200 Z", center: [185, 180] },
  "Zacatecas": { path: "M 215 160 L 270 155 L 285 200 L 270 250 L 225 255 L 210 210 Z", center: [245, 205] },
  "San Luis Potosí": { path: "M 275 170 L 320 165 L 340 220 L 320 280 L 275 285 L 265 230 Z", center: [295, 225] },
  "Nayarit": { path: "M 105 220 L 145 215 L 160 260 L 145 300 L 110 305 L 95 265 Z", center: [125, 260] },
  "Jalisco": { path: "M 150 240 L 220 235 L 245 290 L 225 350 L 160 360 L 140 300 Z", center: [185, 295] },
  "Aguascalientes": { path: "M 225 235 L 255 232 L 265 260 L 255 285 L 230 288 L 220 260 Z", center: [240, 260] },
  "Guanajuato": { path: "M 260 260 L 310 255 L 325 300 L 310 340 L 265 345 L 255 300 Z", center: [285, 300] },
  "Querétaro": { path: "M 310 280 L 345 275 L 360 310 L 350 345 L 320 350 L 305 315 Z", center: [330, 315] },
  "Hidalgo": { path: "M 350 300 L 385 295 L 400 335 L 385 370 L 355 375 L 345 340 Z", center: [370, 335] },
  "Colima": { path: "M 140 350 L 175 345 L 190 380 L 175 410 L 145 415 L 135 385 Z", center: [160, 380] },
  "Michoacán": { path: "M 175 335 L 255 330 L 280 390 L 255 450 L 185 460 L 165 400 Z", center: [215, 390] },
  "Estado de México": { path: "M 340 340 L 385 335 L 405 380 L 385 425 L 345 430 L 335 385 Z", center: [365, 385] },
  "CDMX": { path: "M 365 380 L 395 375 L 408 400 L 398 425 L 372 428 L 362 405 Z", center: [382, 400] },
  "Morelos": { path: "M 350 420 L 385 415 L 400 445 L 385 475 L 355 480 L 345 450 Z", center: [370, 445] },
  "Tlaxcala": { path: "M 390 360 L 420 355 L 435 385 L 422 410 L 395 415 L 385 390 Z", center: [405, 385] },
  "Puebla": { path: "M 395 395 L 450 390 L 475 460 L 450 520 L 400 525 L 390 460 Z", center: [430, 455] },
  "Veracruz": { path: "M 400 300 L 460 290 L 500 400 L 480 520 L 420 540 L 390 430 Z", center: [440, 410] },
  "Guerrero": { path: "M 250 440 L 340 430 L 375 510 L 340 580 L 260 590 L 235 520 Z", center: [295, 510] },
  "Oaxaca": { path: "M 350 515 L 450 505 L 490 580 L 460 650 L 370 660 L 340 590 Z", center: [410, 580] },
  "Chiapas": { path: "M 470 560 L 540 550 L 580 620 L 560 700 L 490 710 L 460 640 Z", center: [515, 630] },
  "Tabasco": { path: "M 480 480 L 550 470 L 575 520 L 555 570 L 495 580 L 475 535 Z", center: [520, 525] },
  "Campeche": { path: "M 540 450 L 600 440 L 630 510 L 610 580 L 555 590 L 535 520 Z", center: [575, 515] },
  "Yucatán": { path: "M 580 380 L 660 370 L 690 420 L 670 480 L 600 490 L 575 440 Z", center: [625, 430] },
  "Quintana Roo": { path: "M 660 400 L 720 390 L 750 500 L 720 600 L 665 610 L 650 510 Z", center: [695, 500] },
};

// Map city to state
const CITY_TO_STATE = {
  "Ciudad de México": "CDMX",
  "Guadalajara": "Jalisco",
  "Monterrey": "Nuevo León",
  "Puebla": "Puebla",
  "Tijuana": "Baja California",
  "León": "Guanajuato",
  "Zapopan": "Jalisco",
  "Querétaro": "Querétaro",
  "Mérida": "Yucatán",
  "San Luis Potosí": "San Luis Potosí",
  "Aguascalientes": "Aguascalientes",
  "Hermosillo": "Sonora",
  "Chihuahua": "Chihuahua",
  "Saltillo": "Coahuila",
  "Mexicali": "Baja California",
  "Culiacán": "Sinaloa",
  "Cancún": "Quintana Roo",
  "Acapulco": "Guerrero",
  "Morelia": "Michoacán",
  "Toluca": "Estado de México",
  "Villahermosa": "Tabasco",
  "Tuxtla Gutiérrez": "Chiapas",
  "Durango": "Durango",
  "Torreón": "Coahuila",
  "Oaxaca": "Oaxaca",
  "Veracruz": "Veracruz",
  "Cuernavaca": "Morelos",
  "Mazatlán": "Sinaloa",
  "Xalapa": "Veracruz",
  "Tepic": "Nayarit",
  "Campeche": "Campeche",
  "La Paz": "Baja California Sur",
  "Colima": "Colima",
  "Pachuca": "Hidalgo",
  "Tlaxcala": "Tlaxcala",
  "Zacatecas": "Zacatecas",
  "Guanajuato": "Guanajuato",
  "Playa del Carmen": "Quintana Roo",
  "Puerto Vallarta": "Jalisco",
  "Los Cabos": "Baja California Sur",
  "Roma Norte": "CDMX",
  "Condesa": "CDMX",
  "Polanco": "CDMX",
  "Coyoacán": "CDMX",
  "Santa Fe": "CDMX",
};

const MexicoMap = ({ data = [] }) => {
  const [hoveredState, setHoveredState] = useState(null);
  const [tooltip, setTooltip] = useState({ show: false, x: 0, y: 0, content: null });

  // Aggregate data by state
  const stateData = {};
  data.forEach(city => {
    const state = CITY_TO_STATE[city.city] || city.state;
    if (state) {
      if (!stateData[state]) {
        stateData[state] = { supply: 0, demand: 0, cities: [] };
      }
      stateData[state].supply += city.supply || 0;
      stateData[state].demand += city.demand || 0;
      if (city.supply > 0 || city.demand > 0) {
        stateData[state].cities.push(city);
      }
    }
  });

  // Calculate max density for color scaling
  const maxDensity = Math.max(...Object.values(stateData).map(s => s.supply + s.demand), 1);

  // Get color based on density
  const getColor = (state) => {
    const data = stateData[state];
    if (!data || (data.supply === 0 && data.demand === 0)) {
      return "#E2E8F0"; // slate-200
    }
    const density = data.supply + data.demand;
    const intensity = Math.min(density / maxDensity, 1);
    
    // Gradient from light to dark primary color
    if (intensity > 0.7) return "#9AA500"; // darker primary
    if (intensity > 0.4) return "#ccd500"; // primary
    if (intensity > 0.2) return "#E5EA80"; // lighter primary
    return "#F0F3B3"; // very light primary
  };

  const handleMouseEnter = (state, e) => {
    setHoveredState(state);
    const data = stateData[state];
    setTooltip({
      show: true,
      x: e.clientX,
      y: e.clientY,
      content: {
        state,
        supply: data?.supply || 0,
        demand: data?.demand || 0,
        cities: data?.cities || []
      }
    });
  };

  const handleMouseLeave = () => {
    setHoveredState(null);
    setTooltip({ show: false, x: 0, y: 0, content: null });
  };

  const handleMouseMove = (e) => {
    if (tooltip.show) {
      setTooltip(prev => ({ ...prev, x: e.clientX, y: e.clientY }));
    }
  };

  return (
    <div className="relative" onMouseMove={handleMouseMove}>
      <svg viewBox="0 0 800 750" className="w-full h-auto max-h-[500px]">
        {/* Background */}
        <rect x="0" y="0" width="800" height="750" fill="#F8FAFC" />
        
        {/* States */}
        {Object.entries(MEXICO_STATES).map(([state, { path, center }]) => (
          <g key={state}>
            <path
              d={path}
              fill={getColor(state)}
              stroke={hoveredState === state ? "#384451" : "#94A3B8"}
              strokeWidth={hoveredState === state ? 2 : 1}
              className="transition-all duration-200 cursor-pointer"
              onMouseEnter={(e) => handleMouseEnter(state, e)}
              onMouseLeave={handleMouseLeave}
            />
            {/* State label for states with data */}
            {stateData[state]?.supply > 0 && (
              <circle
                cx={center[0]}
                cy={center[1]}
                r="8"
                fill="#384451"
                className="pointer-events-none"
              />
            )}
          </g>
        ))}
        
        {/* Legend */}
        <g transform="translate(620, 650)">
          <text x="0" y="0" className="text-xs fill-slate-600 font-medium">Densidad</text>
          <rect x="0" y="10" width="30" height="15" fill="#F0F3B3" stroke="#94A3B8" strokeWidth="0.5" />
          <rect x="30" y="10" width="30" height="15" fill="#E5EA80" stroke="#94A3B8" strokeWidth="0.5" />
          <rect x="60" y="10" width="30" height="15" fill="#ccd500" stroke="#94A3B8" strokeWidth="0.5" />
          <rect x="90" y="10" width="30" height="15" fill="#9AA500" stroke="#94A3B8" strokeWidth="0.5" />
          <text x="0" y="40" className="text-[10px] fill-slate-500">Baja</text>
          <text x="100" y="40" className="text-[10px] fill-slate-500">Alta</text>
        </g>
      </svg>

      {/* Tooltip */}
      {tooltip.show && tooltip.content && (
        <div 
          className="fixed z-50 bg-white rounded-lg shadow-xl border border-slate-200 p-4 pointer-events-none"
          style={{ 
            left: tooltip.x + 15, 
            top: tooltip.y + 15,
            maxWidth: "280px"
          }}
        >
          <h3 className="font-bold text-slate-800 mb-2">{tooltip.content.state}</h3>
          <div className="grid grid-cols-2 gap-3 mb-3">
            <div className="bg-green-50 p-2 rounded">
              <p className="text-xs text-green-600">Oferta</p>
              <p className="text-lg font-bold text-green-700">{tooltip.content.supply}</p>
            </div>
            <div className="bg-blue-50 p-2 rounded">
              <p className="text-xs text-blue-600">Demanda</p>
              <p className="text-lg font-bold text-blue-700">{tooltip.content.demand}</p>
            </div>
          </div>
          {tooltip.content.cities.length > 0 && (
            <div>
              <p className="text-xs text-slate-500 mb-1">Ciudades activas:</p>
              <div className="space-y-1">
                {tooltip.content.cities.slice(0, 5).map(city => (
                  <div key={city.city} className="text-xs flex justify-between">
                    <span className="text-slate-600">{city.city}</span>
                    <span className="text-slate-400">{city.supply}S / {city.demand}D</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MexicoMap;
